var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9964 23.8919C14.662 23.8919 14.3817 23.778 14.1556 23.5501C13.9294 23.3222 13.8164 23.0416 13.8164 22.7083V16.1836H7.29169C6.95836 16.1836 6.67775 16.0693 6.44988 15.8407C6.22198 15.6121 6.10803 15.3306 6.10803 14.9963C6.10803 14.6619 6.22198 14.3816 6.44988 14.1555C6.67775 13.9293 6.95836 13.8163 7.29169 13.8163H13.8164V7.29157C13.8164 6.95823 13.9307 6.67763 14.1593 6.44975C14.3878 6.22186 14.6693 6.10791 15.0037 6.10791C15.3381 6.10791 15.6183 6.22186 15.8445 6.44975C16.0706 6.67763 16.1837 6.95823 16.1837 7.29157V13.8163H22.7084C23.0417 13.8163 23.3223 13.9305 23.5502 14.1591C23.7781 14.3877 23.892 14.6692 23.892 15.0036C23.892 15.3379 23.7781 15.6182 23.5502 15.8443C23.3223 16.0705 23.0417 16.1836 22.7084 16.1836H16.1837V22.7083C16.1837 23.0416 16.0694 23.3222 15.8408 23.5501C15.6122 23.778 15.3308 23.8919 14.9964 23.8919Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.d61b7e68.svg";
export { ForwardRef as ReactComponent };